const types = {
    IMAGE_MAPS_REQUEST: 'maps/IMAGE_MAPS_REQUEST',
    IMAGE_MAPS_REQUEST_COMPLETED: 'maps/IMAGE_MAPS_REQUEST_COMPLETED',
};

const createTypes = {
    ADD_IMAGE_MAP_REQUEST: 'maps/ADD_IMAGE_MAP_REQUEST',
};

const updateTypes = {
    UPDATE_IMAGE_MAP_ORDER: 'info/UPDATE_IMAGE_MAP_ORDER',
};

const deleteTypes = {
    DELETE_IMAGE_MAP_REQUEST: 'maps/DELETE_IMAGE_MAP_REQUEST',
    DELETE_IMAGE_MAP_REQUEST_COMPLETED: 'maps/DELETE_IMAGE_MAP_REQUEST_COMPLETED',
};

const mapTypes = {
    SET_MAP: 'maps/SET_MAP',
};

export default {
    ...types,
    ...createTypes,
    ...updateTypes,
    ...deleteTypes,
    ...mapTypes,
};
